export default __webpack_public_path__ + "static/media/litho-demo-branding-agency.5e99b4b1.jpg";